import { Button, Dialog, DialogActions, DialogContent, Typography } from '@mui/material';
import React, { useState } from 'react';

import { SourceDocument } from '../../Types/indexes';

export const convertOpenAICitationsToMarkdownSuperScripts = (text: string): string => {
  const parts: string[] = [];
  let lastIndex = 0;
  const regex = /\*\*FILE\*\*:([^:]+):†(\d+)/g;

  const matches = Array.from(text.matchAll(regex));

  matches.forEach((match) => {
    const matchIndex = match.index ?? 0;
    if (matchIndex > lastIndex) {
      parts.push(text.substring(lastIndex, matchIndex));
    }
    const fileId = match[1]; // captured group for file_id
    const citationIndex = match[2]; // captured group for annotation_index
    parts.push(`^[openai_file_citation_${citationIndex}:${fileId}]^`);
    lastIndex = matchIndex + match[0].length;
  });
  if (lastIndex < text.length) {
    parts.push(text.substring(lastIndex));
  }

  return parts.join('');
};

interface AugmentedResponseWithSourcesProps {
  text: string;
  sources: SourceDocument[];
}

export const AugmentedResponseWithSources: React.FC<AugmentedResponseWithSourcesProps> = ({
  text,
  sources,
}) => {
  const [open, setOpen] = useState(false);
  const [selectedSource, setSelectedSource] = useState<SourceDocument | null>(null);

  const handleClickOpen = (chunkId: string | null) => {
    const sourceDocument = sources.find((s) => s.chunkId === chunkId);

    if (sourceDocument) {
      setSelectedSource(sourceDocument);
      setOpen(true);
      return;
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  if (text.startsWith('[openai_file_citation_')) {
    const match = text.match(/\[openai_file_citation_(\d+):ChunkId-([A-Za-z0-9-]+)\]/);
    const citationIndex = match ? parseInt(match[1], 10) : -1;
    const citationId = match ? `${match[2]}` : null;

    return (
      <>
        <sup
          style={{ color: '#1976d2', cursor: 'pointer' }}
          key={citationIndex}
          onClick={() => handleClickOpen(citationId)}
        >
          [{citationIndex + 1}]
        </sup>
        <Dialog fullWidth open={open} onClose={handleClose}>
          <DialogContent>
            <div onClick={() => window.open(selectedSource?.link, '_blank')}>
              <Typography
                sx={{
                  textDecoration: 'underline',
                  color: '#1976d2',
                  cursor: 'pointer',
                }}
              >
                {selectedSource?.fileName}
              </Typography>
            </div>
            <Typography sx={{ wordWrap: 'break-word', whiteSpace: 'pre-wrap' }}>
              {'...\n'}
              {selectedSource?.chunk}
              {'\n...'}
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Close</Button>
          </DialogActions>
        </Dialog>
      </>
    );
  }
};
